import camelcaseKeys from "camelcase-keys";

const API_ORIGIN = import.meta.env.VITE_API_ORIGIN || "http://localhost:8000";

export const API_URL = `${API_ORIGIN}/api/v2/`;

export async function getCoreData() {
  let res, data;
  try {
    res = await fetch(`${API_URL}core-data/`);
    data = await res.json();
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    return null;
  }
  const coreData = camelcaseKeys(data, { deep: true });
  return coreData;
}

export async function getPageData(path) {
  const url = `${API_URL}pages/with-path/${path}`;
  let res, data;
  try {
    res = await fetch(url);
    data = await res.json();
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    return null;
  }
  if (res.status === 404) {
    return null;
  } else {
    const pageData = camelcaseKeys(data, { deep: true });
    return pageData;
  }
}

export async function getPreviewPageData(contentType, token) {
  const params = new URLSearchParams({
    content_type: contentType,
    token,
  });
  const url = `${API_URL}page_preview/1/?${params}`;
  let res, data;
  try {
    res = await fetch(url);
    data = await res.json();
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    return null;
  }
  if (res.status === 404) {
    return null;
  } else {
    const pageData = camelcaseKeys(data, { deep: true });
    return pageData;
  }
}

export async function postEnquiryForm(formData) {
  let response;
  let errors = [];
  try {
    response = await fetch(API_URL + "enquiries/", {
      method: "POST",
      body: formData,
    });
  } catch {
    errors = {
      nonFieldErrors: ["Sorry, something went wrong. Please try again later."],
    };
    return errors;
  }
  if (response.status === 201) {
    return {
      success: ["Thank you for your message. We'll be in touch shortly."],
    };
  } else {
    try {
      let data = await response.json();
      data = camelcaseKeys(data, { deep: true });
      errors = data;
    } catch {
      errors = {
        nonFieldErrors: [
          "Sorry, something went wrong. Please try again later.",
        ],
      };
    }
  }
  return { errors: errors };
}
